import React, { ReactNode } from 'react'
import ArrowCircleLeftRounded from '@mui/icons-material/ArrowCircleLeftRounded'
import { IconButton, Link, Toolbar } from '@mui/material'
interface QuickSaleMobileAppBarProps {
    title: string | ReactNode
    onClickTitle?: () => void
    handleBackTo?: () => void
    children?: React.ReactNode
    disabled?: boolean
}
const TopToolBar = (props: QuickSaleMobileAppBarProps) => {
    const {
        title,
        handleBackTo,
        onClickTitle,
        children,
        disabled = false,
    } = props

    return (
        <Toolbar
            sx={{
                backgroundColor: (theme) => theme.palette.topside.default,
                pl: handleBackTo ? 0 : undefined,
            }}
        >
            {handleBackTo && (
                <IconButton
                    onClick={handleBackTo}
                    sx={{ pr: 0 }}
                    disabled={disabled}
                >
                    <ArrowCircleLeftRounded
                        fontSize="large"
                        sx={{
                            color: 'primary.contrastText',
                        }}
                    />
                </IconButton>
            )}
            <Link
                underline="none"
                color="inherit"
                onClick={onClickTitle}
                sx={{
                    px: 1,
                    color: 'primary.contrastText',
                    cursor: Boolean(onClickTitle) ? 'pointer' : 'default',
                }}
            >
                {title}
            </Link>
            {children}
        </Toolbar>
    )
}

export default TopToolBar
